import { CouvertTranslations } from ".";

export const COVERT_EN_US: CouvertTranslations = {
	label: "Edit couverts",
	editCouvert: "Edit couvert",
	newCouvert: "Add couvert",
	saveChanges: "Save changes",
	createCouvert: "Create couvert",
	male: "Male",
	female: "Female",
	mesas: "Mesas",
	edit: "Edit",
	add: "Add",
	active: "Active",
	disabled: "Disabled",
	cancel: "Cancel",
	delete: "Delete",
	emptyState: {
		title: "Nothing here yet",
		subtitle: "When you add a new couvert, it will appear here.",
	},
	deleteModal: {
		title: "Do you want to delete this couvert?",
		firstDescription:
			"Upon confirmation, you won't be able to see the couvert anymore and won't be able to apply it in POS operations.",
		secondDescription: "The records in the report will remain in the history.",
		cancel: "Cancel",
		confirm: "Delete couvert",
	},
	columns: {
		public: "Public",
		name: "Name",
		category: "Category",
		price: "Price",
		fiscalProfile: "Fiscal Profile",
		fiscalProductGroup: "Fiscal Product Group",
	},

	placeholders: {
		name: "Define your Couvert name",
		public: "Select the public",
		category: "Select the category",
	},
	alert: {
		title:
			"By enabling fiscal mode, cover charges have been disabled. Update the fiscal data of the cover charges to enable them again.",
		message:
			"The fiscal data for cover charges is required for fiscal issuance. If you still do not have fiscal data for cover charges, add it ",
		action: "by clicking here",
	},
	error: {
		value: {
			required: "This field is required",
			value: "The cover charge amount must be less than or equal to the postpaid limit",
		},
		name: {
			required: "Name is required",
			maxLength: "Name can have up to {{maxLength}} characters",
		},
		category: {
			required: "Category is required",
			maxLength: "Category can have up to {{maxLength}} characters",
		},
		kind: {
			required: "Public is required",
		},
	},
};
